import React from 'react';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import useWindowSize from './useWindowSize';
import StickyBookingWrapper, {
  HotelInfo,
  InfoArea,
  Title,
  Logo,
  HotelAction,
  Price,
  HotelRating
} from './StickyBooking.style';
import { getCurrencySymbol } from 'library/helpers/utils';

const StickyBooking = ({
  logo,
  title,
  price,
  rating,
  action,
  className,
  marina
}) => {
  const addAllClasses = ['sticky_booking'];
  const { t } = useTranslation();
  const windowSize = useWindowSize();
  const windowInnerWidth = process.browser && windowSize.innerWidth;
  const { marina_settings } = marina;
  const marinaCurrnecySymbol = getCurrencySymbol(marina_settings.currency);

  if (className) {
    addAllClasses.push(className);
  }

  return (
    <StickyBookingWrapper
      className={addAllClasses.join(' ')}
      isMobile={isMobile}
    >
      <HotelInfo className='hotel_info'>
        {windowInnerWidth > 767 && (
          <>{logo && <Logo src={logo} alt={title} />}</>
        )}

        {title || rating || price ? (
          <InfoArea>
            {windowInnerWidth > 767 ? (
              <>{title && <Title>{title}</Title>}</>
            ) : (
              <Price>
                <span>
                  {marinaCurrnecySymbol + ' '} {price || '**'}
                </span>
                <span>/{t('TOTAL_PRICE')}</span>
              </Price>
            )}
            {rating && <HotelRating>{rating}</HotelRating>}
          </InfoArea>
        ) : (
          ''
        )}
      </HotelInfo>

      <HotelAction className='hotel_action'>
        {windowInnerWidth > 767 && (
          <Price>
            <span>
              {marinaCurrnecySymbol + ' '} {price || '**'}
            </span>
            <span>{t('TOTAL_PRICE')}</span>
          </Price>
        )}
        {action}
      </HotelAction>
    </StickyBookingWrapper>
  );
};

export default StickyBooking;
